import { createPortal } from 'react-dom';
import { FiCheck, FiChevronRight, FiX } from 'react-icons/fi';

import { StyledButton } from '../StyledButton';
import { Container, Content } from './styles';

interface IProps {
  type: 'success' | 'error';
  text: string;
  setModal: (value: boolean) => void;
  innerHtml?: boolean;
}

const StatusModal = ({ text, type, setModal, innerHtml = false }: IProps) =>
  createPortal(
    <Container>
      <Content>
        {type === 'success' ? <FiCheck size={40} /> : <FiX size={40} />}

        {innerHtml ? (
          <div dangerouslySetInnerHTML={{ __html: text }}></div>
        ) : (
          <p>{text}</p>
        )}
        <StyledButton
          icon={<FiChevronRight />}
          iconPosition="right"
          text="Fechar"
          iconWhiteBackground
          iconBorderRadius
          onClick={() => setModal(false)}
        />
      </Content>
    </Container>,
    document.body
  );

export { StatusModal };
